import { IconButton } from '@mui/material';
import { Favorite, Close } from '@mui/icons-material';

function SwipeActionButton({ onClick, actionType }) {
    const isLikeAction = actionType === 'like';
    return (
        <IconButton
            onClick={onClick}
            size="large"
            sx={{ backgroundColor: '#D9D9D9', zIndex: 0 }}
        >
            {isLikeAction ? (
                <Favorite sx={{ color: '#E86161' }} fontSize="large" />
            ) : (
                <Close sx={{ color: 'black' }} fontSize="large" />
            )}
        </IconButton>
    );
}

export default SwipeActionButton;
